import axios from 'axios';

import api, { addAuthInterceptors } from '@/api';

const geographyAPI = axios.create({
  baseURL: `${api.defaults.baseURL}geographyservice/`,
});
addAuthInterceptors(geographyAPI);
export default geographyAPI;
